import { type ButtonHTMLAttributes, forwardRef } from 'react';

import DateRangeRoundedIcon from '@mui/icons-material/DateRangeRounded';

import cn from '../../../utils/cn';
import Button from '../../Button';

const DatePickerTrigger = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & {
    open?: boolean;
  }
>(({ value, onClick, open }, ref) => {
  const getLabel = () => {
    const label = value?.toLocaleString('pt-BR').split(' - ').filter(Boolean);
    if (!label) return '';
    if (label[0] === label[1]) return label[0];
    return label.join(' - ');
  };

  return (
    <Button
      ref={ref}
      variant='outlined'
      size='condensed'
      color='secondary'
      className={cn(open && 'bg-gray-lightest')}
      startIcon={<DateRangeRoundedIcon />}
      onClick={onClick}
    >
      {getLabel()}
    </Button>
  );
});

export default DatePickerTrigger;
